export const hightLightElement = (element: HTMLElement) => {
  // element.style.transition = 'background-color 0.5s ease';
  // element.style.backgroundColor = 'yellow';
  // setTimeout(() => {
  //   element.style.backgroundColor = '';
  // }, 2000);

  // zoom in and out
  // element.style.transition = 'transform 0.5s ease';
  // element.style.transform = 'scale(1.1)';
  // setTimeout(() => {
  //   element.style.transform = '';
  // }, 2000);

  // add outline
  element.style.border = '2px solid #fa6831';
};
